export default __webpack_public_path__ + "static/media/inventory.34adeb30.svg";